export default {
    modal_move: {
        status: 'Mover Status - {{title}}',
        ticket: 'Mover Ticket - {{title}}',
        all_tickets: 'Mover Todos los Tickets con Estado - {{title}}'
    },
    error: {
        move_tickets: 'No se pueden mover los siguientes tickets',
        archive_tickets: 'No se pueden archivar los siguientes tickets',
    },
    alert: {
        archive_all_tickets_title: '¿Quiere archivar todos los tickets con el estado {{status}}?',
        archive_all_tickets_text: 'Después de archivar los tickets, ya no será posible actualizarlos.',
    },
}
